import { useQuery } from '@tanstack/react-query';

import { api, getQueryProps, isDefined } from 'common';

import { type AnyBlockType, UiBlockType, isBlockType } from '../../types';

interface UseBlockTypeMetadataProps {
  uiBlockType: AnyBlockType | undefined;
}

export function useBlockTypeMetadata(props: UseBlockTypeMetadataProps) {
  const { uiBlockType } = props;
  const blockTypeMetadataResults = useQuery({
    ...getQueryProps(
      api.client.FlowBlockTypeMetadata,
      'findOneByBlockType',
      isBlockType(uiBlockType) ? uiBlockType : UiBlockType.Unknown
    ),
    enabled: isDefined(uiBlockType),
  });
  return blockTypeMetadataResults;
}
